<script lang="ts" setup>
    import { onMounted, ref } from 'vue'
    import { SelectFieldSingle } from '@/js/components/Common'

    const logFileContent = ref('')
    const rows = ref(25)
    const rowsOptions = [25, 50, 100, 1000]
    const props = defineProps({
        filename: {
            type: String,
            default: '',
            required: true
        }
    })

    onMounted(() => {
        reloadLogFile()
    })

    async function reloadLogFile() {
        logFileContent.value = await store.dispatch('logfile/viewImportLog', {
            rows: rows.value,
            filename: props.filename
        })
        logFileContent.value = logFileContent.value.replace(
            /(".*?")/g,
            '<span class="bold">$1</span>'
        )
    }
</script>

<template>
    <select-field-single
        v-if="logFileContent"
        v-model="rows"
        :items="rowsOptions"
        class="rounded-0"
        @update:model-value="reloadLogFile"
    />
    <div v-if="logFileContent">
        <!-- eslint-disable vue/no-v-html -->
        <pre class="pa-2 mb-0 bg-warning" v-html="logFileContent" />
    </div>
    <div v-else class="pa-2 text-muted">keine Logdaten zum Anzeigen vorhanden</div>
</template>

<style scoped>
    div :deep(.bold) {
        font-weight: bold;
    }
</style>
